import { translate } from '../../utils/translation'

export const useTranslation = () => ({
  balance: translate('Saldo em cash'),
  title: translate('Carteira de pontos'),
  applyCashback: translate('Aplicar cashback'),
  checkboxLabel: translate('Usar saldo em cash como desconto'),
  redemptionLimitValue: translate(`Você pode resgatar até %s nesta compra`),
  redemptionLimitValueWithUsed: translate(`Você ainda pode resgatar até %s nesta compra`),
  redemptionLabel: translate('Digite o valor que deseja resgatar da sua carteira:'),
})
